// src/Service/productionApi.js
import axios from 'axios';

// Create a SEPARATE axios instance for production endpoints
const productionApi = axios.create({
  baseURL: '/pos',
});

// Add BOTH tenant ID AND Authorization header
productionApi.interceptors.request.use(config => {
  const tenantId = localStorage.getItem('tenantId');
  const token = localStorage.getItem('sessionToken');
  
  if (tenantId) {
    config.headers['X-TENANTID'] = tenantId;
  }
  
  if (token) {
    // ✅ CRITICAL: Add Authorization header with Bearer prefix
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  
  console.log("📡 Production API Request:", {
    url: config.url,
    headers: config.headers
  });
  
  return config;
});

export default productionApi;
